module.exports = __webpack_public_path__ + "static/media/calendar-exclamation.add1a991.svg";